var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopSaenkelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.124,
    height: 33.866,
    viewBox: "0 0 36.124 33.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M6.705,1.79A2.258,2.258,0,0,1,8.421,1H27.7a2.258,2.258,0,0,1,1.716.79l5.89,6.872a3.387,3.387,0,0,1,.815,2.2v.576a5.362,5.362,0,0,1-9.6,3.292,5.363,5.363,0,0,1-8.467,0,5.363,5.363,0,0,1-8.467,0A5.362,5.362,0,0,1,0,11.442v-.576a3.387,3.387,0,0,1,.815-2.2L6.708,1.788Zm4.019,9.652a3.1,3.1,0,0,0,6.209,0,1.129,1.129,0,0,1,2.258,0,3.1,3.1,0,1,0,6.209,0,1.129,1.129,0,0,1,2.258,0,3.1,3.1,0,0,0,6.209,0v-.576a1.129,1.129,0,0,0-.271-.734L27.7,3.258H8.421L2.529,10.133a1.129,1.129,0,0,0-.271.734v.576a3.1,3.1,0,1,0,6.209,0,1.129,1.129,0,0,1,2.258,0ZM3.387,17.933a1.129,1.129,0,0,1,1.129,1.129V32.608H6.773V21.32a2.258,2.258,0,0,1,2.258-2.258H15.8a2.258,2.258,0,0,1,2.258,2.258V32.608H31.608V19.062a1.129,1.129,0,0,1,2.258,0V32.608h1.129a1.129,1.129,0,1,1,0,2.258H1.129a1.129,1.129,0,0,1,0-2.258H2.258V19.062a1.129,1.129,0,0,1,1.129-1.129ZM9.031,32.608H15.8V21.32H9.031ZM20.32,21.32a2.258,2.258,0,0,1,2.258-2.258h4.515a2.258,2.258,0,0,1,2.258,2.258v6.773a2.258,2.258,0,0,1-2.258,2.258H22.577a2.258,2.258,0,0,1-2.258-2.258Zm6.773,0H22.577v6.773h4.515Z",
    transform: "translate(0 -1)",
    fill: "#368181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopSaenkelt);
export default __webpack_public_path__ + "static/media/shop-saenkelt.e462db728a0a0013dc68351511568ce5.svg";
export { ForwardRef as ReactComponent };